export default "__VITE_ASSET__BctYTxUQ__"